module.exports = __webpack_public_path__ + "static/media/collapse-polygon.d104abd9.svg";